import { Link, useParams } from 'react-router-dom'
import arrow from '../../assets/img/program/arrow.png'
import api from '../../lib/api'
import Moment from 'react-moment'
import 'moment/locale/ru'
import './Program.sass'
import { useEffect, useState } from 'react'
import { MetaTags } from 'react-meta-tags'

export default function Program({ eventId }) {
    const [event, setEvent] = useState()

    const load = () => {
        api
            .service('events')
            .get(eventId)
            .then(setEvent)
    }
    useEffect(load, [eventId])
    return (
        <section className="section-mex">

            {event &&
                <div className="container">
                    <MetaTags>
                        <title>{event.label} | Danogips</title>
                    </MetaTags>
                    <div className="mex">
                        <div className="mex-top">
                            <Link to="/showroom/" className="mex-button">
                                <img src={arrow} alt="" />
                                <span>К программам</span>
                            </Link>

                            <div className="mex-content">
                                <h2 className="mex-title">
                                    {event.label}
                                </h2>
                                {event.date &&
                                    <p><Moment date={event.date} format="DD MMMM YYYY" locale="ru" /></p>
                                }
                            </div>

                        </div>

                        <h3 className="rasp__title">Программа</h3>
                        <div>
                            {event.program.map(item => (
                                <div className="rasp" key={item.time}>
                                    <div className="rasp__time">{item.time}</div>
                                    <div className="rasp__text">{item.text}</div>
                                </div>
                            ))}
                        </div>

                        <div className="mex-block">
                            {event.description.map((item, index) => (
                                <div className="mex-item" key={index}>
                                    <div className="mex-number">{index + 1}</div>
                                    <div className="mex-text">{item.text}</div>
                                </div>
                            ))}

                        </div>

                    </div>

                </div>
            }
        </section>
    )
}